import styled, { css } from 'styled-components';
import { Link as link } from 'react-router-dom';

export const Form = styled.form``;

const a = css``;

export const Link = styled(link)`
  ${a};
`;
export const LinkExternal = styled.a`
  ${a};
`;

export const Text = styled.p`
  font-size: 12px;
  color: #777;
  a {
    font-size: 12px;
  }
`;

export const Description = styled.p`
  margin-bottom: 30px;
  margin-top: -15px;
`;



// WEBPACK FOOTER //
// ./src/assets/styles/components.js